import React from "react";
import { Box, Typography } from "@mui/material";
import costIcon from "@iconify/icons-mdi/cash";
import projectIcon from "@iconify/icons-mdi/chart-gantt";
import timerOutlineIcon from "@iconify/icons-mdi/timer-outline";
import clientIcon from "@iconify/icons-mdi/user-tie";
import { InlineIcon } from "@iconify/react";

// Define the type for the request object
interface Request {
  name?: string;
  projectName?: string;
  clientName?: string;
  costName?: string;
}

export const MyTimesheetShowRequestDialogData = ({
  request,
  width,
}: {
  request: Request;
  width?: string;
}) => {
  return (
    <Box
      style={{
        padding: "8px 16px",
        backgroundColor: "#E3E5E5",
        borderRadius: "4px",
        width: width ? width : "320px",
      }}
    >
      <Box display="flex" flexDirection="row">
        <InlineIcon
          icon={timerOutlineIcon}
          width="24px"
          style={{
            marginRight: "8px",
            color: "#cc0033",
          }}
        />
        <Typography variant="body1" color="primary">
          {request?.name}
        </Typography>
      </Box>
      {request?.projectName && (
        <Box display="flex" flexDirection="row">
          <InlineIcon
            icon={projectIcon}
            width="24px"
            style={{
              marginRight: "8px",
            }}
          />
          <Typography variant="body1">{request?.projectName}</Typography>
        </Box>
      )}
      {request?.clientName && (
        <Box display="flex" flexDirection="row">
          <InlineIcon
            icon={clientIcon}
            width="24px"
            style={{
              marginRight: "8px",
            }}
          />
          <Typography variant="body1">{request?.clientName}</Typography>
        </Box>
      )}
      {request?.costName && (
        <Box display="flex" flexDirection="row">
          <InlineIcon
            icon={costIcon}
            width="24px"
            style={{
              marginRight: "8px",
            }}
          />
          <Typography variant="body1">{request?.costName}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default MyTimesheetShowRequestDialogData;
